module.exports = __webpack_public_path__ + "fe5a1bb7024d89e000604ff64e5cc34c.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/exterior_thumb.jpg
// module id = 470
// module chunks = 0